import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { ScaleButton } from '@cloudorder/ui';

import { PageHead } from '@/shared/ui/PageHead';

export function NotFoundPage(): ReactElement {
  const { t } = useTranslation('app');

  return (
    <>
      <PageHead title={t('notFound.title')} sub={t('notFound.sub')} />
      <Link to="/">
        <ScaleButton size="small" variant="primary">
          {t('notFound.back')}
        </ScaleButton>
      </Link>
    </>
  );
}
